import script from "./TeamStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamStatus.vue?vue&type=script&lang=ts&setup=true"

import "./TeamStatus.vue?vue&type=style&index=0&id=35d1a04e&lang=sass"

const __exports__ = script;

export default __exports__